import type { ReactNode } from 'react';
import { useCompliance } from '../api/queries';
import { dateTimeLabel } from '../copy';
import styles from './PoliticalField.module.css';
import ui from './ui.module.css';

/**
 * "Enquete política" (legal review 2026-09-28). Checking it submits the poll to
 * the rules the API enforces by itself — nothing here enforces anything:
 *
 *   - off the air during every electoral blackout (Res. TSE 23.600/2019 art. 23):
 *     each even year from 16 August to the end of the last Sunday of October,
 *     plus any window added under Conformidade;
 *   - only signed-in voters aged 18+ who gave the specific consent may vote
 *     (LGPD art. 11 — a political opinion is sensitive data);
 *   - the app labels it an enquete with no statistical value, never a pesquisa.
 */
export function PoliticalField({
  checked,
  onChange,
  blocked,
  disabled,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Off the air right now because of the calendar (the row's `electoral_blocked`). */
  blocked?: boolean;
  disabled?: boolean;
}): ReactNode {
  const { data } = useCompliance();
  const until = data?.electoral.until ?? null;

  return (
    <div className={ui.field}>
      <label className={styles.check}>
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(event) => onChange(event.target.checked)}
        />
        <span>
          Enquete política
          <span className={ui.muted}> — candidatos, partidos, governantes ou eleições</span>
        </span>
      </label>

      {checked ? (
        <ul className={styles.rules}>
          <li>Sai do ar sozinha durante o período eleitoral (16/ago até o fim do último domingo de outubro, anos pares) e em períodos extras cadastrados.</li>
          <li>Só vota quem entrou com WhatsApp, tem 18 anos ou mais e deu o consentimento específico para dado sensível.</li>
          <li>O app mostra o aviso “enquete sem valor científico — não é pesquisa eleitoral”.</li>
        </ul>
      ) : null}

      {checked && (blocked || data?.electoral.blackout) ? (
        <p className={styles.blocked}>
          {blocked ? 'Fora do ar agora' : 'Ficará fora do ar'}: período eleitoral
          {until ? ` até ${dateTimeLabel(until)}` : ''}.
        </p>
      ) : null}
    </div>
  );
}
